import { computed, getCurrentInstance, inject, onUnmounted, ref } from 'vue'

import type {
  ComponentInternalInstance,
  ComponentPublicInstance,
  InjectionKey,
} from 'vue'

type ParentProvide<T> = T & {
  link(child: ComponentInternalInstance): void
  unlink(child: ComponentInternalInstance): void
  children: ComponentPublicInstance[]
  internalChildren: ComponentInternalInstance[]
}

export function useParent<T>(
  key: InjectionKey<ParentProvide<T>>,
  noLinkParent = false
) {
  const parent = inject(key, null)

  if (parent && !noLinkParent) {
    const instance = getCurrentInstance()!
    const { link, unlink, internalChildren } = parent

    link(instance)
    onUnmounted(() => unlink(instance))

    const index = computed(() => internalChildren.indexOf(instance))

    return {
      parent,
      index,
    }
  }

  return {
    parent: null,
    index: ref(-1),
  }
}
